module.exports = "../images/fishing-lodge-3-14.jpg?v=8b72608";